import { createContext, useContext } from 'react';

export type Role = 'designer' | 'manager' | 'top-manager' | 'developer' | 'unknown';

export type SalonOption = {
    id: string;
    name: string;
};

export type AuthUser = {
    username: string;
    email?: string | null;
    unique_name?: string | null;
    role: Role;
    salon_id: string | null;
    available_salons?: SalonOption[];
    is_guest?: boolean;
};

export type AuthContextValue = {
    user: AuthUser | null;
    isAuthenticated: boolean;
    isCheckingAuth: boolean;
    signOut: () => void;
};

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
    const ctx = useContext(AuthContext);
    if (!ctx) {
        throw new Error('useAuth must be used within AuthProvider');
    }
    return ctx;
}

export function isManager(user: AuthUser | null): boolean {
    return (
        user?.role === 'manager' ||
        user?.role === 'top-manager' ||
        user?.role === 'developer'
    );
}

export function isDeveloper(user: AuthUser | null): boolean {
    return user?.role === 'developer';
}
